export default __webpack_public_path__ + "static/it-bef9e6916d2420a94c2a24e1454950cc.svg";